const ACTION_TYPES = { UPDATE_CURRENT_LOCATION: 'update-current-location' };

const initialState = {
    path: null,
    queryParams: null,
    anchor: null
};


const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_CURRENT_LOCATION: {
            let {
                path, queryParams, anchor, prevPath 
            } = action.location;
            return Object.assign({}, state, {
                path, queryParams, anchor, prevPath 
            });
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
